module.exports = __webpack_public_path__ + "img/gallery-img-2.2b634921.jpg";